module.exports = __webpack_public_path__ + "img/watage_res_15.157d2e6c.gif";